import { getItemFromCollection } from "directus/src/operations";

export async function fetchProjectDataforForm({ id, fields }) {
  try {
    const query = {
      fields,
    };

    const response = await getItemFromCollection("projects", id, query);
    return response;
  } catch (error) {
    console.error(error);

    throw error;
  }
}
